var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53974 6.29004L1.87974 0.640037C1.78677 0.546308 1.67617 0.471914 1.55431 0.421145C1.43246 0.370377 1.30175 0.344238 1.16974 0.344238C1.03773 0.344238 0.90702 0.370377 0.785161 0.421145C0.663302 0.471914 0.552701 0.546308 0.459738 0.640037C0.273487 0.827399 0.168945 1.08085 0.168945 1.34504C0.168945 1.60922 0.273487 1.86267 0.459738 2.05004L5.40974 7.05004L0.459738 12C0.273487 12.1874 0.168945 12.4409 0.168945 12.705C0.168945 12.9692 0.273487 13.2227 0.459738 13.41C0.552352 13.5045 0.662797 13.5797 0.784673 13.6312C0.906548 13.6827 1.03743 13.7095 1.16974 13.71C1.30204 13.7095 1.43293 13.6827 1.5548 13.6312C1.67668 13.5797 1.78712 13.5045 1.87974 13.41L7.53974 7.76004C7.64124 7.66639 7.72225 7.55274 7.77766 7.42624C7.83307 7.29974 7.86167 7.16314 7.86167 7.02504C7.86167 6.88693 7.83307 6.75033 7.77766 6.62383C7.72225 6.49733 7.64124 6.38368 7.53974 6.29004Z",
    fill: "#797B86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArr);
export default __webpack_public_path__ + "static/media/rightArr.866659f747f63d64521f42eacf2f59fc.svg";
export { ForwardRef as ReactComponent };